import { channelList } from '@/mocks/channels';
import { clamp, TRANSITION, COLORS } from './progress';

interface CTASceneProps {
  progress: number;
}

export default function CTAScene({ progress }: CTASceneProps) {
  const p = clamp(progress, 0, 1);
  const enter = clamp(p * 2.5, 0, 1);
  const opacity = enter;
  const translateY = (1 - enter) * 50;

  return (
    <div
      className="absolute inset-0 z-20 flex items-center justify-center px-5 md:px-8 pt-20 md:pt-24 pb-10 pointer-events-none"
      style={{ opacity, transform: `translateY(${translateY}px)`, transition: TRANSITION, willChange: 'transform, opacity' }}
    >
      <div className="w-full max-w-4xl text-center">
        <div className="flex items-center justify-center gap-3 mb-6">
          <span className="w-10 h-px bg-white/40" />
          <span className="font-manrope text-white/70 text-[10px] uppercase tracking-[0.35em]">
            Vol. 06 — 尋找下一本書
          </span>
          <span className="w-10 h-px bg-white/40" />
        </div>

        <h2
          className="font-semibold text-white leading-tight mb-6"
          style={{ fontSize: 'clamp(26px, 4vw, 48px)' }}
        >
          從精選開始，找到下一本值得閱讀的書
        </h2>

        <p className="font-manrope text-sm md:text-base text-white/65 leading-relaxed max-w-xl mx-auto mb-8">
          從茶文化、商業、科普、醫療保健、心理學及人文社科等主題出發，透過策點文化的正式出版內容，找到符合目前閱讀需求的作品。
        </p>

        {/* 主要入口 */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10 pointer-events-auto">
          <a
            href="https://catalog.sonbook.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-7 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 inline-flex items-center gap-2"
            style={{ backgroundColor: COLORS.cream, color: COLORS.ink }}
          >
            前往書籍資料庫
            <i className="ri-arrow-right-up-line text-sm"></i>
          </a>
          <a
            href="https://sonbook.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="px-7 py-3 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 inline-flex items-center gap-2"
            style={{ backgroundColor: 'rgba(255,255,255,0.12)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' }}
          >
            前往崧博出版
            <i className="ri-external-link-line text-sm"></i>
          </a>
        </div>

        {/* 合作通路 */}
        <div className="mb-10">
          <p className="font-manrope text-[10px] uppercase tracking-[0.3em] text-white/45 mb-4">
            合作購書通路
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2.5 pointer-events-auto">
            {channelList.slice(0, 9).map((channel) => (
              <a
                key={channel.id}
                href={channel.url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-manrope whitespace-nowrap cursor-pointer transition-colors duration-200"
                style={{ backgroundColor: 'rgba(255,255,255,0.05)', color: 'rgba(255,255,255,0.75)', border: '1px solid rgba(255,255,255,0.14)' }}
              >
                <i className={`${channel.icon} text-sm`}></i>
                {channel.name}
              </a>
            ))}
          </div>
        </div>

        {/* 內容責任 */}
        <div className="border-t pt-6" style={{ borderColor: 'rgba(255,255,255,0.12)' }}>
          <p className="font-manrope text-[11px] text-white/40 leading-relaxed max-w-2xl mx-auto">
            網站內容為出版與一般知識資訊，各主題不能取代醫療、心理、投資、法律、教育或其他專業人員的評估與建議。個別作品內容與作者觀點，不代表策點文化或崧博出版的官方立場。
          </p>
          <p className="font-manrope text-[10px] text-white/30 mt-3">
            &copy; 2026 策點文化事業有限公司 STRATDOT
          </p>
        </div>
      </div>
    </div>
  );
}
